import React from 'react';
import { Container, Row, Col } from 'shared-portal-component';

import '@/components/atoms/Chart/SeatsLegend/SeatsLegend.scss';

interface SeatsLegendItem {
  label: string;
  color: string;
  value: number | string;
}

interface SeatsLegendProps {
  items: SeatsLegendItem[];
  className?: string;
}

/**
 * Use inside <Legend content={<SeatsLegend items={...} />} />.
 * Recharts will inject width/height props which we simply ignore here.
 */
const SeatsLegend: React.FC<SeatsLegendProps & Record<string, unknown>> = ({
  items,
  className = '',
}) => (
  <Container fluid className={`seats-legend ${className}`}>
    {items.map((it) => (
      <Row key={it.label} spacing="md" align="center">
        {/* swatch */}
        <Col size="content">
          <span className="seats-legend__swatch" style={{ background: it.color }} />
        </Col>

        {/* label */}
        <Col>
          <span className="seats-legend__label">{it.label}</span>
        </Col>

        {/* value */}
        <Col size="content">
          <span className="seats-legend__value">{it.value}</span>
        </Col>
      </Row>
    ))}
  </Container>
);

export default SeatsLegend;
